import {
    Table,
    TableContainer,
    Tbody,
    Td,
    Th,
    Thead,
    Tr,
  } from '@chakra-ui/react';
  import { useState, useEffect } from 'react';
  import axios from 'axios';
  import { FaPhone, FaWhatsapp, FaBirthdayCake, FaPhoneAlt } from 'react-icons/fa';
  import { Card, CardHeader, CardBody, CardFooter, SimpleGrid } from '@chakra-ui/react';
  import { useDispatch, useSelector } from 'react-redux';
  import { leadGet } from '../../../redux/actions/Files.action';
  import moment from 'moment';
  import { BASEURL } from 'baseUrl';
  
  export default function BirthdayList() {
    const dispatch = useDispatch();
    const getFile = useSelector((state) => state.files);
    const [todayBirthdays, setTodayBirthdays] = useState([]);
    const [selectedDate, setSelectedDate] = useState(moment().format('YYYY-MM-DD'));
    const [selectedName, setSelectedName] = useState('');
  
    useEffect(() => {
      dispatch(leadGet(1, 10)); // Fetch all leads with high limit
    }, []);
  
    useEffect(() => {
      if (getFile?.getAllLead?.data?.PatientData) {
        const filterDate = moment(selectedDate).format('MM-DD');
        const birthdays = getFile.getAllLead.data.PatientData.filter(patient => {
          if (!patient.dateOfBirth) return false;
          const dob = moment(patient.dateOfBirth).format('MM-DD');
          return dob === filterDate;
        });
        setTodayBirthdays(birthdays);
      }
    }, [getFile, selectedDate]);
  
    const handlePhoneClick = (phoneNumber) => {
      window.location.href = `tel:${phoneNumber}`;
    };
  
    const openWhatsapp = (phoneNumber, firstName, lastName) => {
      const fullName = `${firstName}`;
      // Birthday card image URL - replace with your actual hosted image URL
      // const birthdayImageUrl = "../../../../public/Mizo-fav.png";  
      const message = `Dear ${fullName},\n\nHappy Birthday! 🎉🎂\n\nWe at SmartX CRM wish you a wonderful birthday filled with joy and happiness. Thank you for being a valued part of our family.\n\nBest Regards,\nSmartX CRM Team`;
      // const message = `Dear ${fullName},\n\nHappy Birthday! 🎉🎂\n\nWe at Trip Well wish you a wonderful birthday filled with joy and happiness. Thank you for being a valued part of our family.\n\nBest Regards,\nTRIP WELL Team`;
      const encodedMessage = encodeURIComponent(message);
      window.open(`https://web.whatsapp.com/send?phone=${phoneNumber}&text=${encodedMessage}`, '_blank');
    };
  
    const handleNameClick = (firstName, lastName) => {
      const fullName = `${firstName} ${lastName}`;
      setSelectedName(selectedName === fullName ? '' : fullName);
    };
  
    return (
      <div className="mt-[100px]">
        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4 mb-8">
          {/* Title section - always on top for mobile */}
          <div className="flex items-center">
          <FaBirthdayCake className="text-[#F15A30] text-2xl" />
            <h2 className="text-2xl font-bold ml-3">
              {moment(selectedDate).isSame(moment(), 'day')
                ? "Today's Birthdays"
                : `Birthdays on ${moment(selectedDate).format('MMMM Do')}`
              }
            </h2>
          </div>
  
          {/* Filter controls - below title on mobile, right-aligned on desktop */}
          <div className="flex flex-wrap items-center gap-2">
            <label htmlFor="birthday-date" className="text-sm font-medium text-gray-700 whitespace-nowrap">
              Filter by date:
            </label>
            <div className="flex flex-1 min-w-[200px] gap-2">
              <input
                id="birthday-date"
                type="date"
                value={selectedDate}
                onChange={(e) => setSelectedDate(e.target.value)}
                className="flex-1 border border-gray-300 rounded px-3 py-2 focus:ring-2 focus:ring-yellow-500 focus:border-yellow-500 text-sm"
              />
              <button
                onClick={() => setSelectedDate(moment().format('YYYY-MM-DD'))}
                className="bg-[#F15A30] hover:bg-[#d94f29] text-white px-3 py-2 rounded text-sm whitespace-nowrap"
              >
                Today
              </button>
  
            </div>
          </div>
        </div>
  
        {/* Birthday count indicator */}
        <p className="text-gray-600 mb-4">
          {todayBirthdays.length} {todayBirthdays.length === 1 ? 'person' : 'people'} celebrating {moment(selectedDate).isSame(moment(), 'day') ? 'today' : 'on this day'}
        </p>
  
        {/* Rest of your component */}
        {selectedName && (
          <div className="fixed bottom-4 right-4 bg-yellow-100 text-yellow-800 px-4 py-2 rounded-lg shadow-lg z-50 animate-fade-in">
            {selectedName}
          </div>
        )}
  
        {todayBirthdays.length > 0 ? (
          <div className="space-y-4">
            {todayBirthdays.map((patient) => (
              <Card
                key={patient._id}
                className="rounded-lg overflow-hidden shadow-md transition-all duration-300 transform hover:shadow-xl hover:scale-[1.01]"
              >
                <div className="flex flex-col md:flex-row">
                  {/* Left Side - Icon & Image */}
                  <div className="bg-yellow-100 p-4 flex items-center justify-center md:w-1/5">
                    <div className="bg-yellow-50 p-3 rounded-full">
                      <FaBirthdayCake className="text-yellow-500 text-2xl" />
                    </div>
                  </div>
  
                  {/* Middle - Patient Info */}
                  <div className="bg-yellow-50 p-4 flex-1">
                    <div className="flex flex-col h-full justify-center">
                      <div className="flex items-center mb-2">
                        <h3
                          className="text-lg font-semibold text-gray-800 cursor-pointer hover:text-yellow-600 transition-colors"
                          onClick={() => handleNameClick(patient.firstName, patient.lastName)}
                        >
                          {patient.firstName} {patient.lastName}
                        </h3>
                        <span className="bg-yellow-100 text-yellow-800 text-xs px-3 py-1 rounded-full ml-3 inline-flex items-center">
                          🎉 Birthday
                        </span>
                      </div>
                      <p className="text-gray-600 mb-2">{patient.phoneNumber}</p>
                      <p className="text-gray-500">
                        Born on {moment(patient.dateOfBirth).format('MMMM Do, YYYY')}
                        {/* <span className="text-yellow-700 ml-2">
                          ({moment().diff(moment(patient.dateOfBirth), 'years')} years old)
                        </span> */}
                      </p>
                    </div>
                  </div>
  
                  {/* Right Side - Actions */}
                  <div className="bg-yellow-50 p-4 flex flex-row justify-center items-center space-x-4 md:w-1/6">
                    <button
                      onClick={() => handlePhoneClick(patient.phoneNumber)}
                      className="bg-blue-500 hover:bg-blue-600 transition-colors text-white p-3 rounded-full"
                      aria-label="Call"
                    >
                      <FaPhoneAlt className="text-xl" />
                    </button>
                    <button
                      onClick={() => openWhatsapp(patient.phoneNumber, patient.firstName, patient.lastName)}
                      className="bg-green-500 hover:bg-green-600 transition-colors text-white p-3 rounded-full"
                      aria-label="WhatsApp"
                    >
                      <FaWhatsapp className="text-xl" />
                    </button>
                  </div>
                </div>
              </Card>
            ))}
          </div>
        ) : (
          <div className="text-center py-12 bg-white rounded-lg shadow-sm">
            <FaBirthdayCake className="text-gray-300 text-5xl mx-auto" />
            <p className="mt-4 text-xl text-gray-500 font-medium">
              No birthdays to celebrate today
            </p>
          </div>
        )}
  
  
  
  
  
      </div>
    );
  }